import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

export default class Contact extends Component {
  render() {
    // const { getInterface } = this.props;

    return (
      <div className={`flex justify-center`}>
        <div className="w-full lg:w-7/12 p-4 lg:px-0 lg:py-4">
          <h3 className="text-3xl font-semibold mt-8">
            Talk to Nikola Arinanda
          </h3>
          <p className="mt-10 mb-2">
            Untuk kebutuhan bisnis ataupun kerjasama silakan menghubungi saya
            melalui email dan no berikut:
          </p>
          <div>
            <FontAwesomeIcon icon={faEnvelope} />
            <a
              href="mailto:nikolarinanda@gmail.com"
              className="ml-2 font-semibold text-cyan-600 hover:text-cyan-500"
            >
              nikolarinanda@gmail.com
            </a>
          </div>
          <div>
            <FontAwesomeIcon icon={faPhone} />
            <a
              href="https://wa.me/6289632002447"
              className="ml-2 font-semibold text-cyan-600 hover:text-cyan-500"
            >
              +6289632002447
            </a>
          </div>
        </div>
      </div>
    );
  }
}
